import React from 'react'
import { ProductWidget as ProductWidgetCore } from '../ProductWidget/index'
import type { Product } from '@ztechapps/common.contract'
import { useBillOfMaterialsContext } from './Context'

export const BomProductWidget = (props: Product) => {
  const { canEdit } = useBillOfMaterialsContext()

  return <ProductWidgetCore title={props?.name || props?.code} code={props?.code} _id={props?._id} canEdit={canEdit} />
}
